import { Outlet } from "@tanstack/react-router"
import { Layout } from "@mimber/ui-web"
import { AppHeader } from "@/components/blocks"

const { Header, Content } = Layout

export function OrganizationsLayout() {
  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <Header
        style={{
          padding: 0,
          display: "flex",
          alignItems: "center",
          position: "sticky",
          top: 0,
          zIndex: 1,
          width: "100%",
        }}
      >
        <AppHeader />
      </Header>

      <Content
        style={{
          margin: "24px 16px",
          borderRadius: "8px",
          height: "calc(100vh - 64px)",
          overflowY: "auto",
        }}
      >
        <Outlet />
      </Content>
    </Layout>
  )
}
